import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHeading = styled.header.withConfig({
  displayName: "Heading__StyledHeading"
})(({
  theme,
  variant
}) => ({
  fontFamily: theme.typography[variant].fontFamily,
  fontSize: theme.typography[variant].fontSize,
  fontWeight: theme.typography[variant].fontWeight,
  wordBreak: 'break-word'
}));
const Headings = ({
  children,
  variant
}) => {
  return /*#__PURE__*/_jsx(StyledHeading, {
    variant: variant,
    children: children
  });
};
export default Headings;